/**
 * JINSA – Cotización Manager
 * Carrito de cotización en localStorage. El PDF NO se genera en el navegador:
 * se envía un POST con los datos al backend (vía webhook de n8n, que reenvía
 * server-to-server a quotes.jinsa.com.mx para evitar el bloqueo de CORS) y
 * éste responde con la URL del PDF ya generado (type=url).
 */
(function () {
  'use strict';

  const STORAGE_KEY  = 'jinsa_cotizacion_lista';
  const JINSA_PHONE  = '526182929220'; // WhatsApp E.164
  const JINSA_EMAIL  = 've1@jinsa.com.mx';
  const JINSA_WEB    = 'www.jinsa.com.mx';
  const JINSA_NOMBRE = 'JINSA';

  // Mismo webhook de n8n que usa FERRE: reenvía server-to-server al generador
  // de PDF y responde JSON con la URL del PDF ya generado (no el binario).
  const COTIZACION_ENDPOINT = 'https://automatization.jinsa.com.mx/webhook/5b44a4e1-479f-4dcd-944c-33d606d011d0';
  const EMPRESA_TEMPLATE    = 'JINSA'; // Selector de plantilla visual del PDF en el backend.

  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  }

  function saveItems(items) {
    items.forEach((p, i) => { p.no = String(i + 1); });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('jinsaCotizacionActualizada'));
  }

  function removeItem(variantId) {
    saveItems(getItems().filter(p => String(p._variantId) !== String(variantId)));
  }

  function updateQty(variantId, qty) {
    const items = getItems();
    const item  = items.find(p => String(p._variantId) === String(variantId));
    if (item) { item.cantidad = Math.max(1, parseInt(qty) || 1); saveItems(items); }
  }

  function fmt(n) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: 'MXN', minimumFractionDigits: 2
    }).format(n);
  }

  // ── Badge counter ─────────────────────────────────────────────────────────
  function updateCounters() {
    const items = getItems();
    const total = items.reduce((s, p) => s + (parseInt(p.cantidad) || 1), 0);
    document.querySelectorAll('.cotizacion-count-bubble').forEach(el => {
      el.textContent = total;
      el.classList.toggle('visible', total > 0);
    });
  }

  // ── Page rendering (tabla de la página de cotización) ────────────────────
  function renderPage() {
    const container = document.getElementById('jinsa-cotizacion-container');
    if (!container) return;

    const items = getItems();
    updateCounters();

    if (items.length === 0) {
      container.innerHTML = `
        <div class="jinsa-cotizacion-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <p>No hay productos en tu cotización todavía.</p>
          <a href="/" class="button">Explorar productos</a>
        </div>`;
      return;
    }

    const rows = items.map(item => {
      const pFinal   = parseFloat(item._precioFinal) || parseFloat(item.precioUnitario) || 0;
      const pOrig    = parseFloat(item.precioUnitario) || pFinal;
      const qty      = parseInt(item.cantidad) || 1;
      const hasDisc  = item.descuento > 0 && pOrig > pFinal;
      const subtotal = pFinal * qty;
      return `
        <tr>
          <td>
            <div class="jinsa-cotiz-product-info">
              <img src="${item._img || ''}" alt="" class="jinsa-cotiz-product-img" onerror="this.style.display='none'">
              <div>
                <div class="jinsa-cotiz-product-sku">${item.modelo || '—'}</div>
                <div class="jinsa-cotiz-product-title">${item.descripcion}</div>
                <div class="jinsa-cotiz-product-brand">${item.marca || ''}</div>
              </div>
            </div>
          </td>
          <td>
            <input type="number" min="1" value="${qty}" class="jinsa-cotiz-qty-input" data-variant="${item._variantId}">
          </td>
          <td>
            ${hasDisc ? `<span class="price--compare-cotiz">${fmt(pOrig)}</span>` : ''}
            <strong>${fmt(pFinal)}</strong>
            ${hasDisc ? `<span class="jinsa-cotiz-discount-tag">-${item.descuento}%</span>` : ''}
          </td>
          <td><strong>${fmt(subtotal)}</strong></td>
          <td>
            <button class="jinsa-cotiz-remove-btn" data-variant="${item._variantId}" title="Eliminar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </td>
        </tr>`;
    }).join('');

    container.innerHTML = `
      <div class="jinsa-cotizacion-table-wrapper">
        <table class="jinsa-cotizacion-table">
          <thead>
            <tr>
              <th>Producto</th>
              <th style="width:80px">Cant.</th>
              <th>Precio Unit.</th>
              <th>Subtotal</th>
              <th style="width:48px"></th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
      <div class="jinsa-cotiz-totals" id="jinsa-cotiz-totals-row"></div>
      <div style="text-align:right">
        <button class="jinsa-cotiz-btn-danger" id="jinsa-cotiz-clear-btn">Vaciar cotización</button>
      </div>`;

    renderTotals(items);
    bindTableEvents();
  }

  function renderTotals(items) {
    const el = document.getElementById('jinsa-cotiz-totals-row');
    if (!el) return;
    const sub   = items.reduce((s, p) => s + (parseFloat(p._precioFinal) || 0) * (parseInt(p.cantidad) || 1), 0);
    const iva   = sub * 0.16;
    const total = sub + iva;
    el.innerHTML = `
      <table class="jinsa-cotiz-totals-table">
        <tr><td class="label-cell">Subtotal:</td><td class="value-cell">${fmt(sub)}</td></tr>
        <tr><td class="label-cell">IVA (16%):</td><td class="value-cell">${fmt(iva)}</td></tr>
        <tr class="total-row"><td class="label-cell">Total:</td><td class="value-cell">${fmt(total)}</td></tr>
      </table>`;
  }

  function bindTableEvents() {
    document.querySelectorAll('.jinsa-cotiz-remove-btn').forEach(btn => {
      btn.addEventListener('click', () => { removeItem(btn.dataset.variant); renderPage(); });
    });
    document.querySelectorAll('.jinsa-cotiz-qty-input').forEach(input => {
      input.addEventListener('change', () => {
        updateQty(input.dataset.variant, input.value);
        renderTotals(getItems());
      });
    });
    const clearBtn = document.getElementById('jinsa-cotiz-clear-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (confirm('¿Deseas vaciar toda la cotización?')) { saveItems([]); renderPage(); }
      });
    }
  }

  function getFormData() {
    const g = (id) => (document.getElementById(id) || {}).value || '';
    return {
      nombre:    g('cotiz-nombre'),
      empresa:   g('cotiz-empresa'),
      direccion: g('cotiz-direccion'),
      rfc:       g('cotiz-rfc'),
      telefono:  g('cotiz-telefono'),
      email:     g('cotiz-email'),
      formaPago: g('cotiz-forma-pago') || 'CONTADO'
    };
  }

  // ── Payload compartido (página + drawer) ──────────────────────────────────
  function buildPayload(cliente, items) {
    const cotizacionId = 'WEB-JI-' + String(Math.floor(1000 + Math.random() * 9000));

    return {
      empresa: EMPRESA_TEMPLATE,
      origen: 'WEB',
      cliente: {
        nombre: cliente.nombre,
        razonSocial: cliente.empresa,
        direccion: cliente.direccion,
        rfc: cliente.rfc,
        telefono: cliente.telefono,
        correo: cliente.email,
        condicionesPago: cliente.formaPago
      },
      cotizacion: {
        numero: cotizacionId,
        expedidaPor: 'Venta Web'
      },
      productos: items.map(p => ({
        no: Number(p.no),
        modelo: p.modelo,
        descripcion: p.descripcion,
        marca: p.marca,
        cantidad: parseInt(p.cantidad) || 1,
        um: p.um || 'PZA',
        precioUnitario: parseFloat(p.precioUnitario) || 0,
        descuento: parseFloat(p.descuento) || 0,
        imagen: p._img || '',
        urlProducto: p._url || '',
        variantId: p._variantId
      }))
    };
  }

  // ── Solicitar PDF al backend ──────────────────────────────────────────────
  async function requestPDF(cliente, btn) {
    const items = getItems();
    if (!items.length) { alert('Agrega productos a la cotización primero.'); return; }
    if (!cliente.nombre || !cliente.email) {
      alert('Ingresa al menos Nombre y Correo para generar la cotización.');
      return;
    }

    const original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = '⏳ Generando documento...'; btn.disabled = true; }

    const payload = buildPayload(cliente, items);

    try {
      const response = await fetch(COTIZACION_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Error en el servidor');

      const contentType = response.headers.get('Content-Type') || '';

      let pdfUrl = '';
      if (contentType.includes('application/json')) {
        const data = await response.json();
        // El backend puede responder con distintas keys según su versión;
        // se revisan las más comunes en vez de asumir una sola.
        pdfUrl = data.url || data.pdfUrl || data.fileUrl || data.downloadUrl
          || data.link || (data.data && (data.data.url || data.data.pdfUrl)) || '';
        if (!pdfUrl) throw new Error('El backend no devolvió una URL de PDF válida.');
      } else {
        // Respaldo por si el backend responde el binario en vez de una URL.
        const blob = await response.blob();
        pdfUrl = window.URL.createObjectURL(blob);
      }

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = pdfUrl;
      a.target = '_blank';
      a.rel = 'noopener';
      a.download = `Cotización_${payload.cotizacion.numero}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      dataLayer.push({event: 'cotizacion_pdf_generada', ubicacion: 'pagina'});

      if (btn) {
        btn.textContent = '✅ ¡Cotización generada!';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 3000);
      }
    } catch (error) {
      console.error('Error al generar la cotización:', error);
      alert('Hubo un problema al generar la cotización. Por favor intenta de nuevo.');
      if (btn) { btn.textContent = original; btn.disabled = false; }
    }
  }

  // ── WhatsApp send ─────────────────────────────────────────────────────────
  function sendToAdvisor(cliente) {
    const items = getItems();
    if (!items.length) { alert('Agrega productos a la cotización primero.'); return; }

    let msg = `🛒 *Solicitud de Cotización ${JINSA_NOMBRE}*\n\n`;
    if (cliente.nombre)    msg += `👤 *Contacto:* ${cliente.nombre}\n`;
    if (cliente.empresa)   msg += `🏢 *Empresa:* ${cliente.empresa}\n`;
    if (cliente.rfc)       msg += `📋 *RFC:* ${cliente.rfc}\n`;
    if (cliente.telefono)  msg += `📞 *Tel:* ${cliente.telefono}\n`;
    if (cliente.email)     msg += `📧 *Email:* ${cliente.email}\n`;
    if (cliente.direccion) msg += `📍 *Dirección:* ${cliente.direccion}\n`;
    msg += `💳 *Pago:* ${cliente.formaPago || 'CONTADO'}\n\n*PRODUCTOS:*\n`;

    items.forEach((p, i) => {
      const pFinal = parseFloat(p._precioFinal) || parseFloat(p.precioUnitario) || 0;
      msg += `${i + 1}. [${p.modelo}] ${p.descripcion} × ${p.cantidad} = ${fmt(pFinal * p.cantidad)}\n`;
    });

    const sub = items.reduce((s, p) => s + (parseFloat(p._precioFinal) || 0) * (parseInt(p.cantidad) || 1), 0);
    msg += `\n💰 *Total + IVA:* ${fmt(sub * 1.16)}`;

    window.open(`https://wa.me/${JINSA_PHONE}?text=${encodeURIComponent(msg)}`, '_blank');

    dataLayer.push({event: 'cotizacion_whatsapp_asesor', ubicacion: 'pagina'});
  }

  function addItem({ id, sku, title, brand, price, compareAtPrice, img, url }) {
    const items  = getItems();
    const exists = items.findIndex(i => i._variantId === String(id));
    const priceFinal  = parseFloat(price) / 100;
    const priceOrig   = parseFloat(compareAtPrice) / 100;
    const discountPct = priceOrig > priceFinal ? Math.round((priceOrig - priceFinal) / priceOrig * 100) : 0;

    if (exists >= 0) {
      items[exists].cantidad = (parseInt(items[exists].cantidad) || 1) + 1;
    } else {
      items.push({
        _variantId:   String(id),
        _precioFinal: priceFinal,
        _img:         img || '',
        _url:         url || '',
        modelo:       sku || '—',
        descripcion:  title,
        marca:        brand || '',
        precioUnitario: priceOrig || priceFinal,
        descuento:    discountPct,
        cantidad:     1
      });
    }
    saveItems(items);
  }

  // ── Prellenar formulario con datos del cliente logueado (si existen) ─────
  function prefillFromCustomer() {
    const c = window.JinsaCustomer;
    if (!c) return;
    const set = (id, value) => {
      const el = document.getElementById(id);
      if (el && !el.value && value) el.value = value;
    };
    set('cotiz-nombre', c.nombre);
    set('cotiz-empresa', c.empresa);
    set('cotiz-direccion', c.direccion);
    set('cotiz-telefono', c.telefono);
    set('cotiz-email', c.email);
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    updateCounters();

    window.addEventListener('jinsaCotizacionActualizada', () => {
      updateCounters();
      if (document.getElementById('jinsa-cotizacion-container')) renderPage();
    });

    if (document.getElementById('jinsa-cotizacion-container')) {
      renderPage();
      prefillFromCustomer();
      document.getElementById('jinsa-cotiz-generate-pdf')?.addEventListener('click', (e) => {
        requestPDF(getFormData(), e.currentTarget);
      });
      document.getElementById('jinsa-cotiz-send-advisor')?.addEventListener('click', () => {
        sendToAdvisor(getFormData());
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.JinsaCotizacion = {
    updateCounters,
    addItem,
    getItems,
    removeItem,
    updateQty,
    requestPDF,
    sendToAdvisor
  };
})();